export default {
  API_URL: '/gateway'
};
